








import { Component, Vue } from 'vue-property-decorator';
import html2canvas from 'html2canvas';

/** 转换图片函数参数 */
type ToImageOptions = {
  /** 目标DOM元素 */
  target?: HTMLElement,
  /** 背景颜色 */
  backgroundColor?: string;
};

@Component
export default class SaveImage extends Vue {
  // 图片链接
  private dataURL = '';
  // 图片样式
  private imgStyle = {};
  /**
   * 获取传入的模板DOM
   */
  public getTargetDom()  {
    const target = (this.$slots.default || [])[0];
    if (!target.elm) return;
    const targetDom = target.elm as HTMLElement;
    return targetDom;
  }
  // 生成图片方法
  public async toImage(options: ToImageOptions) {
    const { target, backgroundColor = null } = options;
    const targetDom = target || this.getTargetDom();
    if (!targetDom) return;
    const { width, height, top, left } = targetDom.getBoundingClientRect();
    // 获取页面滚动高度
    const getOffsetY = () => {
      const { pageYOffset } = window;
      const documentScrollTop = document.documentElement.scrollTop;
      const bodyScrollTop = document.body.scrollTop;
      return pageYOffset || documentScrollTop  || bodyScrollTop;
    };
    this.imgStyle = {
      width: `${width}px`,
      height: `${height}px`,
    };

    const canvas = await html2canvas(targetDom, {
      useCORS: true,
      width,
      height,
      scale: window.devicePixelRatio || 1,
      backgroundColor,
      x: left,
      y: getOffsetY() + top, // 修复获取图片定位高度不准的问题
    });
    const dataURL = canvas.toDataURL('image/png');

    this.dataURL = dataURL;
    // 图片生成完成事件
    this.$emit('imgDone');
  }
}
